import React, { useMemo, useState } from 'react';

import { Tab, Button } from 'semantic-ui-react';

import { useSavedReports } from './_hooks/savedReports';
import { SavedReportsHeader } from './stateless';
import { getTabPanes } from './tabs/config';
import { ViewAccessWrapper, Drawer, EditSavedReport } from '../../components';
import { buildReportFields } from '../../components/SavedReports/helpers';
import ReportDetails from '../../components/SavedReports/ReportDetails';
import { ScheduledReportsForm } from '../../components/ScheduledReportsForm';
import { SAVED_REPORTS } from '../../constants/views';
import { useGlobalState } from '../../hooks/global';

const SavedReportsContent = ({ newExportDrawerOpen, setNewExportDrawerOpen }) => {
  const { segments } = useGlobalState();
  const {
    savedReports,
    handleGetSavedReports,
    deleteSavedReport,
    scheduledReports,
    deleteScheduledReport,
    handleGetScheduledReports,
    reportDeliveries,
    loading,
  } = useSavedReports();
  const [editSavedReportDrawerOpen, setEditSavedReportDrawerOpen] = useState(false);
  const [editSavedReport, setEditSavedReport] = useState({});
  const [reportDetailsDrawerOpen, setReportDetailsDrawerOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [allReportDetailsDrawerOpen, setAllReportDetailsDrawerOpen] = useState(false);
  const [selectedAllReport, setSelectedAllReport] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handlePostSuccess = () => {
    handleGetScheduledReports();
    setRefreshKey(prev => prev + 1);
  };

  const mySavedReports = useMemo(() => (savedReports.filter(x => x.shared === 0)), [savedReports]);
  const sharedSavedReports = useMemo(() => (savedReports.filter(x => x.shared === 1)), [savedReports]);

  const manage_params = {
    deleteSavedReport,
    handleGetSavedReports,
    openEditDrawer: () => setEditSavedReportDrawerOpen(true),
    onEditButtonClick: item => setEditSavedReport(item),
    openDetailsDrawer: () => setReportDetailsDrawerOpen(true),
    onDetailsButtonClick: item => setSelectedReport(item),
    openAllDetailsDrawer: () => setAllReportDetailsDrawerOpen(true),
    onAllDetailsButtonClick: item => setSelectedAllReport(item),
  };

  const allReportsManageParams = {
    ...manage_params,
    openDetailsDrawer: manage_params.openAllDetailsDrawer,
    onDetailsButtonClick: manage_params.onAllDetailsButtonClick,
  };

  const scheduledReportsManageParams = {
    ...manage_params,
    deleteSavedReport: deleteScheduledReport,
    handleGetSavedReports: handleGetScheduledReports,
  };

  const panes = getTabPanes({
    loading,
    scheduledReports,
    segments,
    scheduledReportsManageParams,
    reportDeliveries,
    allReportsManageParams,
    mySavedReports,
    sharedSavedReports,
    manage_params,
    refreshKey,
  });

  return (
    <>
      <Tab panes={panes} />
      <Drawer openDrawer={editSavedReportDrawerOpen} onDrawerClose={() => setEditSavedReportDrawerOpen(false)}>
        <EditSavedReport
          savedReport={editSavedReport}
          onClose={() => setEditSavedReportDrawerOpen(false)}
          open={editSavedReportDrawerOpen}
          refresh={handleGetSavedReports}
        />
      </Drawer>
      <Drawer openDrawer={reportDetailsDrawerOpen} onDrawerClose={() => setReportDetailsDrawerOpen(false)}>
        <ReportDetails fields={buildReportFields(selectedReport, segments)} title="Report Details" />
      </Drawer>
      <Drawer openDrawer={allReportDetailsDrawerOpen} onDrawerClose={() => setAllReportDetailsDrawerOpen(false)}>
        <ReportDetails fields={buildReportFields(selectedAllReport, segments)} title="Report Details" />
      </Drawer>
      <Drawer openDrawer={newExportDrawerOpen} onDrawerClose={() => setNewExportDrawerOpen(false)}>
        <ScheduledReportsForm
          onFormClose={() => setNewExportDrawerOpen(false)}
          open={newExportDrawerOpen}
          defaultConversionId=""
          defaultCustomerType=""
          defaultAttributionModel=""
          defaultDateRange={null}
          segments={segments}
          onPostSuccess={handlePostSuccess}
        />
      </Drawer>
    </>
  );
};

const SavedReports = () => {
  const [newExportDrawerOpen, setNewExportDrawerOpen] = useState(false);

  return (
    <>
      <SavedReportsHeader
        topRight={(
          <Button primary onClick={() => setNewExportDrawerOpen(true)}>
            New Report
          </Button>
        )}
      />
      <SavedReportsContent
        newExportDrawerOpen={newExportDrawerOpen}
        setNewExportDrawerOpen={setNewExportDrawerOpen}
      />
    </>
  );
};

const SavedReportsWrapper = () => (
  <ViewAccessWrapper
    viewName={SAVED_REPORTS}
    viewComponent={<SavedReports />}
  />
);

export default SavedReportsWrapper;
